import React from "react";
import PropTypes from "prop-types";
import { Box, Paper, Typography } from "@mui/material";
import { AppButton } from "components/common/buttons";

const defaultCardSx = {
  border: "1px solid var(--sub-border, #e8edf2)",
  borderRadius: "10px",
  backgroundColor: "#fff",
  overflow: "hidden",
};

const defaultHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
  minHeight: 44,
  px: 2.5,
  py: 1,
  borderBottom: "1px solid var(--sub-border-light, #e8edf2)",
};

const defaultBodySx = {
  p: 2.25,
};

export default function AppSectionCard({
  title,
  subtitle,
  action,
  icon,
  children,
  elevation = 0,
  className,
  sx,
  headerSx,
  bodySx,
  ...props
}) {
  const hasHeader = Boolean(title || subtitle || action || icon);

  return (
    <Paper
      elevation={elevation}
      className={`app-section-card ${className || ""}`.trim()}
      sx={{ ...defaultCardSx, ...sx }}
      {...props}
    >
      {hasHeader && (
        <Box
          className="app-section-card__header"
          sx={{ ...defaultHeaderSx, ...headerSx }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
            {icon && (
              <Box
                component="span"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  color: "primary.main",
                  "& svg": { fontSize: 20 },
                }}
              >
                {icon}
              </Box>
            )}
            <Box sx={{ minWidth: 0 }}>
              {title && (
                typeof title === "string" ? (
                  <Typography variant="subtitle1" fontWeight={700} sx={{ lineHeight: 1.3 }}>
                    {title}
                  </Typography>
                ) : (
                  title
                )
              )}
              {subtitle && (
                typeof subtitle === "string" ? (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                    {subtitle}
                  </Typography>
                ) : (
                  subtitle
                )
              )}
            </Box>
          </Box>
          {action && (
            <Box sx={{ flexShrink: 0 }}>
              {typeof action === "string" ? (
                <AppButton size="small">{action}</AppButton>
              ) : (
                action
              )}
            </Box>
          )}
        </Box>
      )}
      <Box
        className="app-section-card__body"
        sx={{ ...defaultBodySx, ...bodySx }}
      >
        {children}
      </Box>
    </Paper>
  );
}

AppSectionCard.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  action: PropTypes.node,
  icon: PropTypes.node,
  children: PropTypes.node,
  elevation: PropTypes.number,
  className: PropTypes.string,
  sx: PropTypes.object,
  headerSx: PropTypes.object,
  bodySx: PropTypes.object,
};
